import { API_BASE_URL } from "./api";

const appBasePath = import.meta.env.BASE_URL.replace(/\/$/, "");

function pageOrigin(): string {
  return typeof window !== "undefined" && window.location ? window.location.origin : "http://localhost";
}

/**
 * Liga que el visor de documentos (`/admin/documento`, `/player/documento`)
 * puede mostrar en su `<img>` o `<iframe>`, o "" si no es aceptable.
 *
 * El `src` llega en la URL del visor, así que cualquiera puede armar un link
 * con `?src=javascript:…` y mandarlo por WhatsApp. React 18 en producción no
 * bloquea `javascript:` en un `<iframe src>`: el script correría dentro de
 * torneos123.com y podría leer la sesión guardada. Por eso solo se aceptan
 * archivos de `/uploads/` de torneos123 (mismo origen que la página o que el
 * API), por http(s), sin usuario/contraseña en la URL. Se devuelve la URL ya
 * normalizada, nunca el texto crudo que llegó.
 */
export function safeDocumentSrc(raw: string | null | undefined): string {
  const value = (raw ?? "").trim();
  if (!value) return "";
  const origin = pageOrigin();
  let parsed: URL;
  try {
    parsed = new URL(value, origin);
  } catch {
    return "";
  }
  if (parsed.protocol !== "https:" && parsed.protocol !== "http:") return "";
  if (parsed.username || parsed.password) return "";

  const allowedOrigins = new Set<string>([origin]);
  const prefixes = new Set<string>(["/uploads/", `${appBasePath}/uploads/`]);
  try {
    const api = new URL(API_BASE_URL, origin);
    allowedOrigins.add(api.origin);
    prefixes.add(`${api.pathname.replace(/\/api\/v2\/?$/, "").replace(/\/$/, "")}/uploads/`);
  } catch {
    // Sin base de API válida: solo el origen de la página.
  }
  if (!allowedOrigins.has(parsed.origin)) return "";
  if (![...prefixes].some((prefix) => parsed.pathname.startsWith(prefix))) return "";
  return parsed.href;
}
